module.exports = __webpack_public_path__ + "static/media/case.135a95ef.png";